import { render, staticRenderFns } from "./pos-fmi-by-resource.vue?vue&type=template&id=a5e6c2d6&scoped=true&"
import script from "./pos-fmi-by-resource.vue?vue&type=script&lang=ts&"
export * from "./pos-fmi-by-resource.vue?vue&type=script&lang=ts&"
import style0 from "./pos-fmi-by-resource.vue?vue&type=style&index=0&id=a5e6c2d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e6c2d6",
  null
  
)

export default component.exports